import React from "react";
import backgroundPatternLeftGraphics from "../assets/images/left-background-pattern-blocks.svg";
import backgroundPatternRightGraphics from "../assets/images/right-background-pattern-blocks.svg";

export enum BackgroundBlockPatternOrientation {
    Left = "left",
    Right = "right",
    Both = "both"
}

export interface BackgroundBlockPatternType {
    active?: boolean;
    orientation?: BackgroundBlockPatternOrientation;
}

export interface BackgroundBlockPatternProps extends BackgroundBlockPatternType {
    color?: string;
    classNames?: string;
    zIndexClass?: string;
    margins?: {
        leftBlockMarginLeft?: string;
        rightBlockMarginLeft?: string;
        baseBlockMarginTop?: string;
    };
}

const BackgroundBlockPattern = ({
    active,
    orientation,
    color = "brand-primary-70",
    classNames = "",
    zIndexClass = "-z-1",
    margins
}: BackgroundBlockPatternProps) => {

    const commonClassNames = "relative transform top-0 hidden lg:block text-background-blocks";

    if (active) {
        const svgs: JSX.Element[] = [];

        if (
            orientation === BackgroundBlockPatternOrientation.Left ||
            orientation === BackgroundBlockPatternOrientation.Both
        ) {
            let leftSvgClassNames = "left-0 -translate-x-1/2";

            if (orientation === BackgroundBlockPatternOrientation.Both) {
                leftSvgClassNames += " mt-20";
            }

            svgs.push(
                <div
                    key={svgs.length}
                    className={`${commonClassNames} ${zIndexClass} ${classNames} ${leftSvgClassNames}`}
                    style={{
                        ...margins?.leftBlockMarginLeft && { marginLeft: margins?.leftBlockMarginLeft }
                    }}
                >
                    <svg
                        width={692}
                        height={828}
                        viewBox={backgroundPatternLeftGraphics.viewBox}
                        className={`text-${color} stroke-current`}
                    >
                        <use xlinkHref={backgroundPatternLeftGraphics.url} />
                    </svg>
                </div>
            );
        }

        if (
            orientation === BackgroundBlockPatternOrientation.Right ||
            orientation === BackgroundBlockPatternOrientation.Both
        ) {
            let rightSvgClassNames = "left-full -translate-x-full";

            if (!margins?.rightBlockMarginLeft) {
                rightSvgClassNames += " -ml-72";
            }

            if (orientation === BackgroundBlockPatternOrientation.Both) {
                rightSvgClassNames += " -mt-32";
            }

            svgs.push(
                <div
                    key={svgs.length}
                    className={`${commonClassNames} ${zIndexClass} ${classNames} ${rightSvgClassNames}`}
                    style={{
                        ...margins?.rightBlockMarginLeft && { marginLeft: margins?.rightBlockMarginLeft }
                    }}
                >
                    <svg
                        width={1075}
                        height={697}
                        viewBox={backgroundPatternRightGraphics.viewBox}
                        className={`text-${color} stroke-current`}
                    >
                        <use xlinkHref={backgroundPatternRightGraphics.url} />
                    </svg>
                </div>
            );
        }

        let baseClassNames = "";
        if (!margins?.baseBlockMarginTop) {
            baseClassNames += " -mt-16";
        }

        return (
            <div
                className={`flex overflow-x-hidden absolute w-full ${zIndexClass} ${baseClassNames}`}
                style={{
                    ...margins?.baseBlockMarginTop && { marginTop: margins?.baseBlockMarginTop }
                }}
            >
                {svgs}
            </div>
        );
    }
    else {
        return null;
    }
};

export default BackgroundBlockPattern;
